"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var colors = _interopRequireWildcard(require("../../style/colors"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Svg = _styledComponents["default"].svg.withConfig({
  displayName: "Svg",
  componentId: "sc-14mb48u-0"
})(["", ""], function (_ref) {
  var rotate = _ref.rotate;
  return "transform: rotate(".concat(rotate, "deg)");
});

var WarningIcon = function WarningIcon(_ref2) {
  var height = _ref2.height,
      width = _ref2.width,
      stroke = _ref2.stroke,
      rotate = _ref2.rotate,
      viewBox = _ref2.viewBox;
  return _react["default"].createElement(Svg, {
    rotate: rotate,
    width: width,
    height: height,
    viewBox: viewBox,
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("defs", null, _react["default"].createElement("path", {
    d: "M14.0317645 14c.7188366 0 1.0050109-.5122365.6507844-1.1240822L8.65078441 2.4574155c-.3594183-.62081344-.94734239-.61184565-1.30156882 0L1.31745108 12.8759178C.95803278 13.4967313 1.24161738 14 1.96823549 14H14.0317645zm-5.36509783-2H7.33333333v-1.3333333h1.33333334V12zm0-2.66666667H7.33333333V6.66666667h1.33333334v2.66666666z",
    id: "a"
  })), _react["default"].createElement("g", {
    transform: "translate(-1 -2)",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M0 0h16v16H0z"
  }), _react["default"].createElement("use", {
    fill: stroke,
    xlinkHref: "#a"
  })));
};

WarningIcon.propTypes = {
  width: _propTypes.PropTypes.string,
  height: _propTypes.PropTypes.string,
  stroke: _propTypes.PropTypes.string,
  rotate: _propTypes.PropTypes.number,
  viewBox: _propTypes.PropTypes.string
};
WarningIcon.defaultProps = {
  width: '14px',
  height: '14px',
  stroke: colors.red,
  rotate: 0,
  viewBox: '0 0 15 15'
};
var _default = WarningIcon;
exports["default"] = _default;